import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import aboutImage from '../../assets/az/Slide1.jpg';
import abutImage from '../../assets/az/Slide2.jpg';
import boutImage from '../../assets/az/Slide3.jpg';
import otImage from '../../assets/az/Slide4.jpg';
import atImage from '../../assets/az/Slide5.jpg';
import aoImage from '../../assets/az/Slide13.jpg';
import aotmage from '../../assets/az/Slide14.jpg';
import aotIage from '../../assets/az/Slide8.jpg';
import aotIag from '../../assets/az/Slide9.jpg';
import aotIa from '../../assets/az/Slide11.jpg';
import aotIe from '../../assets/az/Slide12.jpg';
import aotae from '../../assets/az/Slide6.jpg';
import aoIae from '../../assets/az/Slide7.jpg';
import atIae from '../../assets/az/Slide15.jpg';
import otIae from '../../assets/az/Slide10.jpg';
import atIa from '../../assets/az/Slidewe.jpg';
import './ImageSlide.css';

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 768, // This means at a viewport width of 768px and below
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can add more breakpoints here if needed
  ],
};

const ImageSlide = () => {
  return (
    <Slider {...settings}>
      <div>
        <img src={aboutImage} alt="About page image 1" />
      </div>
      <div>
        <img src={abutImage} alt="About page image 2" />
      </div>
      <div>
        <img src={boutImage} alt="About page image 3" />
      </div>
      <div>
        <img src={aotIage} alt="About page image 3" />
      </div>
      <div>
        <img src={aotmage} alt="About page image 3" />
      </div>
      <div>
        <img src={aoImage} alt="About page image 3" />
      </div>
      <div>
        <img src={atImage} alt="About page image 3" />
      </div>
      <div>
        <img src={otImage} alt="About page image 3" />
      </div>
      <div>
        <img src={aotIag} alt="About page image 3" />
      </div>
      <div>
        <img src={otIae} alt="About page image 3" />
      </div>
      {/* <div>
        <img src={aotIa} alt="About page image 3" />
      </div>
      <div>
        <img src={aotIe} alt="About page image 3" />
      </div>
      <div>
        <img src={aotae} alt="About page image 3" />
      </div>
      <div>
        <img src={aoIae} alt="About page image 3" />
      </div>
      <div>
        <img src={atIae} alt="About page image 3" />
      </div>
      <div>
        <img src={atIa} alt="About page image 3" />
      </div> */}
    </Slider>
  );
};

export default ImageSlide;
